// Who is signed in. It changes only by signing in or impersonating, which reload or clear the cache, and by the
// account writer, which invalidates it: it never goes stale on its own.
import { queryOptions } from '@tanstack/react-query';

import { appDataKey } from '~/lib/app-data/keys';
import { fetchAppData } from '~/lib/app-data/fetch-app-data';

import type { SignedInSession } from './load-session.server';

export const sessionQuery = queryOptions({
  queryKey: appDataKey('session'),
  queryFn: () => fetchAppData<SignedInSession>('session'),
  staleTime: Infinity,
});
